import React, { ReactNode, useEffect } from 'react';
import { hasAuthParams, useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import ConfirmationPopUpGuard from 'shared/components/confirmation-pop-up/hooks/confirmation-popup-guard';
import Routes from 'shared/enums/routes';
import { finishLoggingIn } from 'shared/features/auth/authentication/utils/logging-in-util';

import Menu from 'features/menu/menu';
import TenantAccessIndicator from 'features/tenants/components/tenant-access-indicator/tenant-access-indicator';
import TenantAccessIndicatorProvider from 'features/tenants/providers/tenant-access-indicator-provider/tenant-access-indicator-provider';
import styles from './base-layout.module.scss';

type Props = { children: ReactNode };

const BaseLayout = ({ children }: Props): React.JSX.Element => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading && !hasAuthParams()) {
      navigate(Routes.Login);
    } else if (auth.isAuthenticated) {
      finishLoggingIn();
    }
  }, [auth.isAuthenticated, auth.isLoading]);

  return (
    <TenantAccessIndicatorProvider>
      <ConfirmationPopUpGuard />
      <TenantAccessIndicator />
      <div className={styles.layoutContainer}>
        <CssBaseline />
        <Menu />
        <div className={styles.layoutBody}>{children}</div>
      </div>
    </TenantAccessIndicatorProvider>
  );
};

export default BaseLayout;
